class ProductCardSlider extends HTMLElement {
	connectedCallback() {
		this.track = this.querySelector('.mm-product-card-slider-track');
		this.slides = Array.from(this.querySelectorAll('.mm-product-card-slider-slide'));
		this.prevButton = this.querySelector('.mm-product-card-slider-arrow--prev');
		this.nextButton = this.querySelector('.mm-product-card-slider-arrow--next');
		this.card = this.closest('.mm-product-card');
		this.mobileQuery = window.matchMedia('(max-width: 768px)');

		this.index = 0;
		this.isDragging = false;
		this.hasDragged = false;
		this.dragStartX = 0;
		this.dragDeltaX = 0;
		this.dragStartOffset = 0;

		this.updateArrows();

		this.prevButton.addEventListener('click', (event) => this.onArrowClick(event, -1));
		this.nextButton.addEventListener('click', (event) => this.onArrowClick(event, 1));

		this.track.addEventListener('pointerdown', this.onPointerDown.bind(this));
		this.track.addEventListener('pointermove', this.onPointerMove.bind(this));
		this.track.addEventListener('pointerup', this.onPointerUp.bind(this));
		this.track.addEventListener('pointercancel', this.onPointerUp.bind(this));
		this.track.addEventListener('click', this.onTrackClick.bind(this), true);

		window.addEventListener('resize', this.onResize.bind(this));
	}

	onArrowClick(event, direction) {
		event.preventDefault();
		event.stopPropagation();
		this.goTo(this.index + direction);
		if (this.mobileQuery.matches) this.card?.classList.add('mm-card-tapped');
	}

	onPointerDown(event) {
		if (event.pointerType === 'mouse' && event.button !== 0) return;
		this.isDragging = true;
		this.hasDragged = false;
		this.dragStartX = event.clientX;
		this.dragDeltaX = 0;
		this.dragStartOffset = this.getOffsetForIndex(this.index);
		if (this.track.setPointerCapture) this.track.setPointerCapture(event.pointerId);
	}

	onPointerMove(event) {
		if (!this.isDragging) return;
		this.dragDeltaX = event.clientX - this.dragStartX;
		if (Math.abs(this.dragDeltaX) > 5) this.hasDragged = true;
		if (!this.hasDragged) return;

		const x = this.dragStartOffset + this.dragDeltaX;
		this.setPosition(x);
	}

	onPointerUp(event) {
		if (!this.isDragging) return;
		this.isDragging = false;
		if (this.track.releasePointerCapture) this.track.releasePointerCapture(event.pointerId);

		if (!this.hasDragged) return;

		const threshold = this.getContainerWidth() * 0.2;
		let targetIndex = this.index;
		if (this.dragDeltaX <= -threshold) targetIndex += 1;
		else if (this.dragDeltaX >= threshold) targetIndex -= 1;

		this.goTo(targetIndex);
		if (this.mobileQuery.matches) this.card?.classList.add('mm-card-tapped');
	}

	onTrackClick(event) {
		if (this.hasDragged) {
			event.preventDefault();
			event.stopPropagation();
			this.hasDragged = false;
			return;
		}

		if (!this.mobileQuery.matches) return;

		if (!this.card?.classList.contains('mm-card-tapped')) {
			event.preventDefault();
			event.stopPropagation();
			this.card?.classList.add('mm-card-tapped');
		}
	}

	onResize() {
		this.setPosition(this.getOffsetForIndex(this.index));
	}

	getContainerWidth() {
		return this.clientWidth;
	}

	getOffsetForIndex(index) {
		return -index * this.getContainerWidth();
	}

	setPosition(x) {
		if (window.gsap) {
			gsap.set(this.track, { x });
		} else {
			this.track.style.transform = `translateX(${x}px)`;
		}
	}

	goTo(index) {
		this.index = Math.max(0, Math.min(index, this.slides.length - 1));
		const x = this.getOffsetForIndex(this.index);

		if (window.gsap) {
			gsap.to(this.track, { x, duration: 0.45, ease: 'power3.out' });
		} else {
			this.track.style.transition = 'transform 0.45s cubic-bezier(0.33, 1, 0.68, 1)';
			this.track.style.transform = `translateX(${x}px)`;
		}

		this.updateArrows();
	}

	updateArrows() {
		this.prevButton.disabled = this.index <= 0;
		this.nextButton.disabled = this.index >= this.slides.length - 1;
	}
}

if (!customElements.get('product-card-slider')) {
	customElements.define('product-card-slider', ProductCardSlider);
}
